import { connect } from 'react-redux';

import Actions from '../../Actions/Creators';
import Unauthenticated from './Component/Unauthenticated';


const mapStateToProps = (state, ownProps) => ({
    isMagicLinkUsed: state.auth.isMagicLinkUsed,
    isMagicLinkSuccess: state.auth.isMagicLinkSuccess
});


const mapDispatchToProps = (dispatch) => ({
  loginUser: (payload, persistent) => dispatch(Actions.loginUser(payload, persistent)),
  loginUsingMagicLink: (magicLink, studentId) => dispatch(Actions.loginUsingMagicLink(magicLink, studentId))
});


export default connect(mapStateToProps, mapDispatchToProps)(Unauthenticated)